import { useEffect } from 'react';

export const usePasswordReset = ({ resetState, resetDependencies }) => {
    useEffect(() => {
        resetState();
    }, resetDependencies);
};
